import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { toast } from "react-toastify";
import {
  HeaderPage,
  TableUsers,
  AddEditUserForm,
} from "../../components/Admin";
import { ModalBasic, ModalConfirm } from "../../components/Common";
import { useUser } from "../../hooks";

export function UsersAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const { loading, users, getUsers, deleteUser } = useUser();

  useEffect(() => {
    getUsers();
  }, [refetch]);

  const openCloseModal = () => setShowModal((prev) => !prev);
  const onRefetch = () => setRefetch((prev) => !prev);

  const addUser = () => {
    const nextKey = modalKey + 1;
    setModalKey(nextKey);
    setTitleModal("Nuevo usuario");
    setContentModal(
      <AddEditUserForm
        key={nextKey}
        onClose={openCloseModal}
        onRefetch={onRefetch}
      />
    );
    openCloseModal();
  };

  const updateUser = (data) => {
    const nextKey = modalKey + 1;
    setModalKey(nextKey);
    setTitleModal("Actualizar usuario");
    setContentModal(
      <AddEditUserForm
        key={nextKey}
        onClose={openCloseModal}
        onRefetch={onRefetch}
        user={data}
      />
    );
    openCloseModal();
  };

  const onDeleteUser = (data) => setDeleteTarget(data);

  const confirmDeleteUser = async () => {
    try {
      await deleteUser(deleteTarget.id);
      toast.success("Usuario eliminado");
      onRefetch();
    } catch (error) {
      console.error(error);
      toast.error("No se pudo eliminar el usuario. Intenta de nuevo.");
    } finally {
      setDeleteTarget(null);
    }
  };

  return (
    <>
      <HeaderPage
        title="Usuarios"
        btnTitle="Nuevo usuario"
        btnClick={addUser}
      />
      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <TableUsers
          users={users}
          updateUser={updateUser}
          onDeleteUser={onDeleteUser}
        />
      )}

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />

      <ModalConfirm
        title="¿Eliminar usuario?"
        content={`Se eliminará "${deleteTarget?.email}" de forma permanente.`}
        show={!!deleteTarget}
        onCloseText="Cancelar"
        onClose={() => setDeleteTarget(null)}
        onConfirmText="Eliminar"
        onConfirm={confirmDeleteUser}
      />
    </>
  );
}
